module.exports = __webpack_public_path__ + "img/1995.0ec6adae.jpg";